export default function readmore() {
    $('.readmore-wrap').readmore({
        moreLink: '<a class="btn btn-light-secondary btn-block" href="#"><i class="fa fa-caret-down"></i> Подробнее</a>',
        lessLink: '<a class="btn btn-light-secondary btn-block" href="#"><i class="fa fa-caret-up"></i> Свернуть</a>',
        collapsedHeight: 600,
    });
}